<template>
  <div class="flex flex-col h-full gap-8">
    <div>
      <!-- 標題 -->
      <p class="text-lg text-center font-500 mb-8">{{ $t('log_in_slogan_title') }}</p>

      <p class="text-sm text-center font-400 mb-3">{{ menuSubTitle }}</p>

      <!-- 社群登入區（非 webview 才顯示） -->
      <template v-if="!isWebview">
        <div class="flex flex-row gap-6 justify-center items-center mb-8">
          <!-- Google icon 按鈕 -->
          <nd-google-login />

          <!-- Apple 登入按鈕 -->
          <nd-apple-login />

          <!-- Facebook icon 按鈕 -->
          <facebook-login />
        </div>

        <!-- divider -->
        <p class="text-center text-sm mb-3">{{ $t('login_continue_with_email') }}</p>
      </template>

      <!-- Email 按鈕區（永遠顯示） -->
      <div class="flex flex-col gap-3">
        <nd-button class="w-full h-10 border-googlegray" bordered @click="authStore.changeAuthStep('sign-up')">
          {{ $t('log_in_create_account_button') }}
        </nd-button>
        <nd-button class="w-full h-10 border-googlegray" bordered @click="authStore.changeAuthStep('login')">
          {{ $t('log_in_title') }}
        </nd-button>
      </div>

      <!-- CTA 文字（如有） -->
      <p v-if="ctaText" class="mt-8 text-center">{{ ctaText }}</p>
    </div>

    <!-- In-app browser 黃色提示框 -->
    <div v-if="isWebview" class="rounded bg-yellow-10 p-4 text-sm">
      {{ $t('login_in_app_browser_notice') }}
    </div>

    <!-- Footer -->
    <div class="flex flex-col gap-2">
      <!-- Divider -->
      <n-divider class="!mb-2 !mt-0 md:!mt-2" />

      <!-- Bottom area: contact + policy -->
      <nd-button type="primary-text" size="mini" @click="handleOpen">
        {{ $t('login_page_contact_us') }}
      </nd-button>
      <p class="text-sm">
        <trans i18n-key="log_in_agreement_statement" :components="transComponents" />
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { NDivider } from 'naive-ui'
import LocaleLink from '@/components/global/locale-link.vue'
import NdGoogleLogin from '@/components/login/nd-google-login.vue'
import NdAppleLogin from '@/components/login/nd-apple-login.vue'
import FacebookLogin from '@/components/login/facebook-login.vue'

import { QueryStringKeys } from '@/constants/commons'
import { useAuthStore } from '@/store/auth'
import { useAppStore } from '@/store/app'

const route = useRoute()
const { t } = useI18n()
const authStore = useAuthStore()
const appStore = useAppStore()

const { handleOpen } = useCustomerService()

const isWebview = computed(() => appStore.isWebview)

const menuSubTitle = computed(() => (isWebview.value ? t('login_in_app_browser_email') : t('login_page_title')))

const ctaText = computed(() => {
  const ctaOptions = [{ condition: !!route.query[QueryStringKeys.REDIRECT_URL]?.includes('/member/coupons'), text: t('log_in_claim_coupon') }]

  return ctaOptions.find(item => item.condition)?.text ?? ''
})

const transComponents = computed(() => ({
  terms: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/policy' }, target: '_blank' } },
  policy: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/privacy' }, target: '_blank' } },
}))
</script>

<style lang="scss" scoped>
:deep(.n-divider__line) {
  --n-color: theme('colors.gray.40');
}
</style>
